// extracted by mini-css-extract-plugin
module.exports = {"btn":"sign_in_button-module__btn___3s7Kk","clever":"sign_in_button-module__clever___31UWJ"};